import { Row, Col, Card } from "react-bootstrap";
import ListWebServiceAccount from "./ListWebServiceAccount";

const ManageWebServiceAccount = () => {

  return (
    <Row >
      <Col xl={11} lg={11} md={11} sm={12}>

        <Card className="p-4" >

          <Card.Body className="text-start">

            <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Manage Web Service Accounts</h1>
            <br />
            <ListWebServiceAccount></ListWebServiceAccount>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default ManageWebServiceAccount;